import { driverApi } from "./driver.api";

export const { useGetDriverQuery, useListDriversByCompanyInfiniteQuery, useSaveDriverMutation } = driverApi;
